'use client';

import { useState, useEffect } from 'react';

export default function useHash() {
    const [hash, setHash] = useState(typeof window !== 'undefined' ? window.location.hash : "");

    useEffect(() => {
        const onHashChange = () => {
            setHash(window ? window.location.hash : "");
        };
        window.addEventListener('hashchange', onHashChange);
        return () => window.removeEventListener('hashchange', onHashChange);
    }, []);
    
    return hash;
};